import React, { useState, useEffect } from "react";

const ExpenseForm = ({ initialData, onSubmit, dataKey, onDelete }) => {
  const defaultData = { amount: 0, description: "", tag: "", date: new Date().valueOf() };

  const [key, setKey] = useState("");
  const [newData, setNewData] = useState(defaultData);
  const [warning, setWarning] = useState(null);

  console.log("newData:", newData);


  useEffect(() => {
    if (initialData) setNewData(initialData);
  }, [initialData]);

  useEffect(() => {
    if (dataKey !== "") setKey(dataKey);
  }, [dataKey]);

  const onChange = (field, value) => {
      setNewData((prev) => ({ ...prev, [field]: value }));
  }

  const submit = (e) => {
    e.preventDefault();

    onSubmit(newData);
  }

  const reset = (e) => {
    e.preventDefault();
    setNewData(initialData || defaultData)
  }

  const remove = (e) => {
    e.preventDefault();
    onDelete(key);
  }


  return (
    <form className="p-3 border rounded">

      <div className="mb-3">
        <label className="form-label">Date</label>
        <input
          type="date"
          className="form-control"
          value={
            newData?.date
              ? new Date(newData.date).toISOString().split("T")[0]
              : new Date().toISOString().split("T")[0]
          }
          onChange={(e) => onChange("date", new Date(e.target.value).valueOf())}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Amount ($)</label>
        <input
          type="number"
          className="form-control"
          value={newData.amount}
          onChange={(e) => onChange("amount", parseFloat(e.target.value))}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Expense Type</label>
        <select
          className="form-select"
          value={newData.tag}
          onChange={(e) => onChange("tag", e.target.value, true)}
        >
          <option value="">Select type</option>
          <option value="car/truck expenses">Car/Truck Expenses</option>
          <option value="commissions and fees">Commissions and Fees</option>
          <option value="contract labor">Contract Labor</option>
          <option value="depreciation">Depreciation</option>
          <option value="insurance">Insurance</option>
          <option value="office expense">Office Expense</option>
          <option value="rent or lease">Rent or Lease</option>
          <option value="supplies">Supplies</option>
          <option value="taxes">Taxes and Licenses</option>
          <option value="travel">Travel</option>
          <option value="gas">Gas</option>
          <option value="maintenance">Parts/Maintenance</option>
          <option value="other">Other</option>
        </select>
      </div>

      <div className="mb-3">
        <label className="form-label">Description</label>
        <input
          type="text"
          className="form-control"
          value={newData.description || ""}
          onChange={(e) => onChange("description", e.target.value)}
        />
      </div>


      <div className='modal-btn-container'>
        <button className="form-danger-btn btn" onClick={remove}>Delete</button>

        <div className="right-buttons">
          <button className="form-secondary-btn btn" onClick={reset}>Reset</button>
          <button className="form-primary-btn btn" onClick={submit}>Submit</button>
        </div>
      </div>

    </form>
  )
};

export default ExpenseForm;
